// import axios from '../../interceptor/axios-config';
import config from '../../config';
import {
    CREATE_SCHOOL_REQUEST,
    CREATE_SCHOOL_SUCCESS,
    CREATE_SCHOOL_FAILURE,
    READ_SCHOOL_REQUEST,
    READ_SCHOOL_SUCCESS,
    READ_SCHOOL_FAILURE,
    UPDATE_SCHOOL_REQUEST,
    UPDATE_SCHOOL_SUCCESS,
    UPDATE_SCHOOL_FAILURE,
    DELETE_SCHOOL_REQUEST,
    DELETE_SCHOOL_SUCCESS,
    DELETE_SCHOOL_FAILURE
  } from './schoolActionTypes';
  
  // Base URL for API
  const API_URL = `${config.apiBaseUrl}/school/`;


export const createSchool = (formData) => async (dispatch) => {
    try {
        console.log(formData);
      const response = await fetch(`${API_URL}createSchool.php`, {
        method: 'POST',
        body: formData,
      });
  
      // Log the response before parsing
      const text = await response.text(); // Get response as text
      console.log("Raw response:", text);
  
      const data = JSON.parse(text); // Then parse to JSON
  
      // Dispatch success action if needed
    //   dispatch({ type: 'CREATE_SCHOOL_SUCCESS', payload: data });
      dispatch({ type: READ_SCHOOL_SUCCESS, payload: data.data });
    } catch (error) {
      console.error("Error creating school profile:", error);
      dispatch({ type: 'CREATE_SCHOOL_FAILURE', payload: error.message });
    }
  };
  

  
  
  // Read Schools Action
  export const readSchools = () => async (dispatch) => {
    try {
      dispatch({ type: READ_SCHOOL_REQUEST });
  
      const response = await fetch(`${API_URL}schoolDetail.php`);
  
      const data = await response.json();
  
      if (response.ok) {
        dispatch({ type: READ_SCHOOL_SUCCESS, payload: data.data });
      } else {
        dispatch({ type: READ_SCHOOL_FAILURE, error: data.message });
      }
    } catch (error) {
      dispatch({ type: READ_SCHOOL_FAILURE, error: 'Network error' });
    }
  };
  
  // Update School Action
  // Async Update Action 
  export const updateSchool = (schoolDetails) => async (dispatch) => {
    try {

      // Call your API to update the school details
      const response = await fetch(`${API_URL}updateDetail.php`, {
        method: 'PUT', // Or PUT depending on your API
        body: JSON.stringify(schoolDetails),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      console.log(response);
      dispatch({
        type: 'UPDATE_SCHOOL_SUCCESS',
        payload: data,
      });
      return data; // Resolving the promise for the then block in handleSubmit
    } catch (error) {
      dispatch({
        type: 'UPDATE_SCHOOL_FAILURE',
        payload: error,
      });
      throw error; // Rejecting the promise for the catch block in handleSubmit
    }
  };
  
  
  // Delete School Action
  export const deleteSchool = (schoolId) => async (dispatch) => {
    try {
      dispatch({ type: DELETE_SCHOOL_REQUEST });
  
      const response = await fetch(`${API_URL}deleteDetail.php`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ school_id: schoolId }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        dispatch({ type: DELETE_SCHOOL_SUCCESS, payload: schoolId });
      } else {
        dispatch({ type: DELETE_SCHOOL_FAILURE, error: data.message });
      }
    } catch (error) {
      dispatch({ type: DELETE_SCHOOL_FAILURE, error: 'Network error' });
    }
  };
  